module.exports = __webpack_public_path__ + "media/app/images/instagram-light-fc4a677735352e9d7ad61da29799c9c4.png";